export default function findPrintPath (
  year, 
  userAssessment, 
  role, 
  assessmentId,
  selectedStudent,
  sumData
) {
  if ((userAssessment && role === 'Student')) {
    return `/assessment/print/${userAssessment.userAssessmentId}`
  }else if(selectedStudent!=='' &&  userAssessment){
    return `/assessment/print/${userAssessment.userAssessmentId}`
  } 
  else {
    return `/assessment/print/${sumData.groupUAId}?g=true&a=${assessmentId}&y=${year}`
  }
}




// WEBPACK FOOTER //
// ./src/helpers/assessment/assessmentDashboard/findPrintPath.js